import React from 'react';
import { Box, formatSnakeCaseToGeneral, Inscription } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import { SourceItemWrapper, SourceWrapper } from './Changeset.styles';

export interface Props {
  id: string;
  type: string;
  source: string;
  planName: string;
  sourceEntryPoint: string;
  isTwoColumnMode?: boolean;
}

const Head: React.FC<Props> = ({ id, planName, source, type, sourceEntryPoint }) => (
  <Box data-testid={`ActivityLog_changeset_${id}_summary`}>
    <SourceWrapper direction="row">
      {planName ? (
        <SourceItemWrapper data-testid={`ActivityLog_changeset_${id}_plan-name`}>
          <Inscription lineHeight="20px" color="textSecondary">Plan name:</Inscription>
          <Inscription color="textBody" weight="bold" lineHeight="20px">{planName}</Inscription>
        </SourceItemWrapper>
      ) : null}
    
      {sourceEntryPoint ? (
        <SourceItemWrapper data-testid={`ActivityLog_changeset_${id}_entry-point`}>
          <Inscription lineHeight="20px" color="textSecondary">Entry point:</Inscription>
          <Inscription lineHeight="20px" color="textBody">{sourceEntryPoint}</Inscription>
        </SourceItemWrapper>
      ) : null}

      {source && !sourceEntryPoint ? (
        <SourceItemWrapper data-testid={`ActivityLog_changeset_${id}_source-of-change`}>
          <Inscription lineHeight="20px" color="textSecondary">Source of change:</Inscription>
          <Inscription lineHeight="20px" color="textBody">{source}</Inscription>
        </SourceItemWrapper>
      ) : null}

      {type ? (
        <SourceItemWrapper data-testid={`ActivityLog_changeset_${id}_action`}>
          <Inscription lineHeight="20px" color="textSecondary">Action:</Inscription>
          <Inscription color="textBody" lineHeight="20px">
            {capitalize(formatSnakeCaseToGeneral(type))}
          </Inscription>
        </SourceItemWrapper>
      ) : null}
    </SourceWrapper>
  </Box>
);

export default Head;
